 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app~5a11b65b": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app~5a11b65b": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"home~31ecd969":"home~31ecd969","legalInformation~5a11b65b":"legalInformation~5a11b65b","panelCharts~panelDatasetViewer~panelMap~panelReports~31ecd969":"panelCharts~panelDatasetViewer~panelMap~panelReports~31ecd969","panelCharts~panelDatasetViewer~panelMap~31ecd969":"panelCharts~panelDatasetViewer~panelMap~31ecd969","panelCharts~46fbf940":"panelCharts~46fbf940","panelCharts~d4265a04":"panelCharts~d4265a04","panelCharts~4e44fb25":"panelCharts~4e44fb25","panelCharts~418d4e86":"panelCharts~418d4e86","panelCharts~9c5b28f6":"panelCharts~9c5b28f6","panelCharts~53bd17ed":"panelCharts~53bd17ed","panelCharts~31c708a5":"panelCharts~31c708a5","panelCharts~e258e298":"panelCharts~e258e298","panelCharts~15f0789d":"panelCharts~15f0789d","panelCharts~cc99a214":"panelCharts~cc99a214","panelCharts~21833f8f":"panelCharts~21833f8f","panelDatasetViewer~panelMap~Сorpus~d939e436":"panelDatasetViewer~panelMap~Сorpus~d939e436","panelDatasetViewer~panelMap~31ecd969":"panelDatasetViewer~panelMap~31ecd969","panelDatasetViewer~31ecd969":"panelDatasetViewer~31ecd969","panelMap~1f20a385":"panelMap~1f20a385","panelMap~29c271b5":"panelMap~29c271b5","panelMap~dbbd9252":"panelMap~dbbd9252","panelMap~4a7e9e0b":"panelMap~4a7e9e0b","panelMap~f71cff67":"panelMap~f71cff67","panelMap~1039ce26":"panelMap~1039ce26","panelMap~ccdeb4be":"panelMap~ccdeb4be","panelMap~f1c67f17":"panelMap~f1c67f17","panelMap~6c319ff0":"panelMap~6c319ff0","panelMap~6a2c624d":"panelMap~6a2c624d","panelReports~21833f8f":"panelReports~21833f8f","Сorpus~31ecd969":"Сorpus~31ecd969"}[chunkId]||chunkId) + "." + {"home~31ecd969":"4c880a65","legalInformation~5a11b65b":"9cb571bd","panelCharts~panelDatasetViewer~panelMap~panelReports~31ecd969":"53124c25","panelCharts~panelDatasetViewer~panelMap~31ecd969":"2037526d","panelCharts~46fbf940":"398da67f","panelCharts~d4265a04":"a1e488cb","panelCharts~4e44fb25":"34535eb3","panelCharts~418d4e86":"b2835f30","panelCharts~9c5b28f6":"c6c9dc07","panelCharts~53bd17ed":"a4440bd6","panelCharts~31c708a5":"8dd4005f","panelCharts~e258e298":"1ab3f731","panelCharts~15f0789d":"45c7f3e4","panelCharts~cc99a214":"ad271a92","panelCharts~21833f8f":"bafd94eb","panelDatasetViewer~panelMap~Сorpus~d939e436":"01136631","panelDatasetViewer~panelMap~31ecd969":"2663366e","panelDatasetViewer~31ecd969":"0fbb5e65","panelMap~1f20a385":"ab2341ee","panelMap~29c271b5":"85b7e2c0","panelMap~dbbd9252":"406512b3","panelMap~4a7e9e0b":"149f8acb","panelMap~f71cff67":"e146dc43","panelMap~1039ce26":"8b7c56b3","panelMap~ccdeb4be":"fc5c9b37","panelMap~f1c67f17":"4acaa94b","panelMap~6c319ff0":"d6b57bd7","panelMap~6a2c624d":"a4add2cd","panelReports~21833f8f":"733520b2","Сorpus~31ecd969":"33d92e31"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"home~31ecd969":1,"panelCharts~panelDatasetViewer~panelMap~panelReports~31ecd969":1,"panelCharts~panelDatasetViewer~panelMap~31ecd969":1,"panelDatasetViewer~panelMap~31ecd969":1,"panelDatasetViewer~31ecd969":1,"panelMap~1f20a385":1,"panelMap~4a7e9e0b":1,"panelMap~f71cff67":1,"panelMap~1039ce26":1,"panelMap~ccdeb4be":1,"panelMap~f1c67f17":1,"panelMap~6a2c624d":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"home~31ecd969":"home~31ecd969","legalInformation~5a11b65b":"legalInformation~5a11b65b","panelCharts~panelDatasetViewer~panelMap~panelReports~31ecd969":"panelCharts~panelDatasetViewer~panelMap~panelReports~31ecd969","panelCharts~panelDatasetViewer~panelMap~31ecd969":"panelCharts~panelDatasetViewer~panelMap~31ecd969","panelCharts~46fbf940":"panelCharts~46fbf940","panelCharts~d4265a04":"panelCharts~d4265a04","panelCharts~4e44fb25":"panelCharts~4e44fb25","panelCharts~418d4e86":"panelCharts~418d4e86","panelCharts~9c5b28f6":"panelCharts~9c5b28f6","panelCharts~53bd17ed":"panelCharts~53bd17ed","panelCharts~31c708a5":"panelCharts~31c708a5","panelCharts~e258e298":"panelCharts~e258e298","panelCharts~15f0789d":"panelCharts~15f0789d","panelCharts~cc99a214":"panelCharts~cc99a214","panelCharts~21833f8f":"panelCharts~21833f8f","panelDatasetViewer~panelMap~Сorpus~d939e436":"panelDatasetViewer~panelMap~Сorpus~d939e436","panelDatasetViewer~panelMap~31ecd969":"panelDatasetViewer~panelMap~31ecd969","panelDatasetViewer~31ecd969":"panelDatasetViewer~31ecd969","panelMap~1f20a385":"panelMap~1f20a385","panelMap~29c271b5":"panelMap~29c271b5","panelMap~dbbd9252":"panelMap~dbbd9252","panelMap~4a7e9e0b":"panelMap~4a7e9e0b","panelMap~f71cff67":"panelMap~f71cff67","panelMap~1039ce26":"panelMap~1039ce26","panelMap~ccdeb4be":"panelMap~ccdeb4be","panelMap~f1c67f17":"panelMap~f1c67f17","panelMap~6c319ff0":"panelMap~6c319ff0","panelMap~6a2c624d":"panelMap~6a2c624d","panelReports~21833f8f":"panelReports~21833f8f","Сorpus~31ecd969":"Сorpus~31ecd969"}[chunkId]||chunkId) + "." + {"home~31ecd969":"c4181ac4","legalInformation~5a11b65b":"31d6cfe0","panelCharts~panelDatasetViewer~panelMap~panelReports~31ecd969":"652c2393","panelCharts~panelDatasetViewer~panelMap~31ecd969":"8ce7ab03","panelCharts~46fbf940":"31d6cfe0","panelCharts~d4265a04":"31d6cfe0","panelCharts~4e44fb25":"31d6cfe0","panelCharts~418d4e86":"31d6cfe0","panelCharts~9c5b28f6":"31d6cfe0","panelCharts~53bd17ed":"31d6cfe0","panelCharts~31c708a5":"31d6cfe0","panelCharts~e258e298":"31d6cfe0","panelCharts~15f0789d":"31d6cfe0","panelCharts~cc99a214":"31d6cfe0","panelCharts~21833f8f":"31d6cfe0","panelDatasetViewer~panelMap~Сorpus~d939e436":"31d6cfe0","panelDatasetViewer~panelMap~31ecd969":"2bb80882","panelDatasetViewer~31ecd969":"8563b29d","panelMap~1f20a385":"bc5ba2da","panelMap~29c271b5":"31d6cfe0","panelMap~dbbd9252":"31d6cfe0","panelMap~4a7e9e0b":"11936c28","panelMap~f71cff67":"110f225e","panelMap~1039ce26":"c62e3e2e","panelMap~ccdeb4be":"3268150d","panelMap~f1c67f17":"ffb3f288","panelMap~6c319ff0":"31d6cfe0","panelMap~6a2c624d":"88484577","panelReports~21833f8f":"31d6cfe0","Сorpus~31ecd969":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors~2d335a83","chunk-vendors~2ebc07f6","chunk-vendors~e4173fa2","chunk-vendors~0fa8f174","chunk-vendors~5d5f8003","chunk-vendors~7e5e8261","chunk-vendors~1869c72c","chunk-vendors~2b13b260","chunk-vendors~2df6c9b7","chunk-vendors~7d359b94","chunk-vendors~1ccf8e8a","chunk-vendors~f9ca8911","chunk-vendors~ec8c427e","chunk-vendors~fdc6512a","chunk-vendors~0605657e","chunk-vendors~d2305125","chunk-vendors~4a7e9e0b","chunk-vendors~793fb972","chunk-vendors~85da75cb","chunk-vendors~ce053847","chunk-vendors~11c2601a","chunk-vendors~8f64ed1d","app~d0ae3f07","app~2898eb0e","app~63defed8"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
